export default "__VITE_ASSET__Di49pgBx__"